const subscription = {
    limit_exceeded: 'Sie haben das Limit Ihres Abonnementplans erreicht.',
    get_plan_failed: 'Fehler beim Abrufen des Abonnementplans für den Mandanten.',
    tenant_suspended: 'Mandant ist gesperrt. Bitte kontaktieren Sie Ihren Administrator.',
};
export default Object.freeze(subscription);
